var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_786_862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0273 4.13623C14.0297 4.13623 22.778 4.13654 24.9668 4.7251C25.5613 4.88724 26.1028 5.203 26.5371 5.64014C26.9714 6.0773 27.2831 6.62075 27.4414 7.21631C28.0236 9.40255 28.0273 13.9483 28.0273 13.9995C28.0273 13.9995 28.0269 18.5851 27.4414 20.7837C27.2831 21.3792 26.9714 21.9227 26.5371 22.3599C26.1028 22.797 25.5613 23.1128 24.9668 23.2749C22.778 23.8635 14.0297 23.8638 14.0273 23.8638C14.0273 23.8638 5.27698 23.8635 3.08789 23.2749C2.49337 23.1128 1.95193 22.797 1.51758 22.3599C1.08326 21.9227 0.771588 21.3792 0.613281 20.7837C0.0278267 18.5851 0.0273438 13.9995 0.0273438 13.9995C0.0273622 13.9483 0.0311262 9.40255 0.613281 7.21631C0.771573 6.62075 1.08326 6.0773 1.51758 5.64014C1.95192 5.203 2.49338 4.88724 3.08789 4.7251C5.27698 4.13646 14.0273 4.13623 14.0273 4.13623ZM11.667 17.6597L18.9844 13.4966L11.667 9.3335V17.6597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_786_862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d9be28a0fbcf4756b1a0ec619072fea7.svg";
export { ForwardRef as ReactComponent };